import { render } from "./CustomRadio.vue.ts?vue&type=template&id=9b72a5d4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomRadio.vue?vue&type=template&id=9b72a5d4&scoped=true&ts=true"
import script from "./CustomRadio.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomRadio.vue?vue&type=script&lang=ts"
export * from "./CustomRadio.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomRadio.vue?vue&type=script&lang=ts"

import "./CustomRadio.vue.scss?vue&type=style&index=0&id=9b72a5d4&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomRadio.vue?vue&type=style&index=0&id=9b72a5d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b72a5d4"],['__file',"src/apps/core-app-onboarding/components/CustomRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b72a5d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b72a5d4', __exports__)) {
    api.reload('9b72a5d4', __exports__)
  }
  
  module.hot.accept("./CustomRadio.vue.ts?vue&type=template&id=9b72a5d4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomRadio.vue?vue&type=template&id=9b72a5d4&scoped=true&ts=true", () => {
    api.rerender('9b72a5d4', render)
  })

}


export default __exports__